import { all, takeEvery, put, call } from 'redux-saga/effects';
import moment from 'moment';
import actions from './actions';
import { tableConfig } from '../../../settings/index';
import Api from '../../../helpers/api';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';

const api = new Api('dashboard/applicants');

function formatApplicants(applicants) {
  return applicants.map(item => {
    if (item.skills.length > 1) {
      item.children = item.skills.map(skill => ({ ...skill, id: item.id }));

      return item;
    }

    if (item.skills.length === 1) {
      return { ...item, ...item.skills[0] };
    }

    return item;
  });
}

function* loadData({ payload }) {
  try {
    const {
      page = 1,
      pageSize = tableConfig.pageSize,
      column,
      order,
      filter = '',
      defaultFilterShowed,
      ...restPayload
    } = payload;
    const search = { ...restPayload, page, pageSize, column, order, filter };

    if (!defaultFilterShowed) {
      search['time[start_time]'] = moment().subtract(7, 'days').format();
      search['time[end_time]'] = moment().format();
    }

    const result = yield call(sendRequest, api.load, { search }, notifications.REQUEST_ERROR);

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records, totalCount, filteredCount, sortableColumns, filters } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data: formatApplicants(records),
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
          filters,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
